import { render, staticRenderFns } from "./def_function.vue?vue&type=template&id=b5d65b26"
import script from "./def_function.vue?vue&type=script&lang=js"
export * from "./def_function.vue?vue&type=script&lang=js"
import style0 from "./def_function.vue?vue&type=style&index=0&id=b5d65b26&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports